import { ButtonProps } from 'react-bootstrap';
import { ColorScheme, StyledButton } from './Button.styles';

/* eslint-disable react/button-has-type */
export interface Props extends ButtonProps {
  children: React.ReactNode;
  $colorScheme?: ColorScheme;
  $noBorder?: boolean;
  bigRounded?: boolean;
  $noOutlineWhenFocus?: boolean;
  /** Icon to be displayed on the left of the button, use Glyphicon for better styling. */
  leftIcon?: React.ReactNode;
  /** Icon to be displayed on the right of the button, use Glyphicon for better styling. */
  rightIcon?: React.ReactNode;
}

const Button = (props: Props) => {
  const { children, bigRounded, leftIcon, rightIcon, ...rest } = props;
  return (
    // @ts-ignore
    <StyledButton
      $bigRounded={bigRounded}
      $hasIcon={!!rightIcon || !!leftIcon}
      {...rest}
    >
      {leftIcon && <div className="left-icon">{leftIcon}</div>}
      {children}
      {rightIcon && <div className="right-icon">{rightIcon}</div>}
    </StyledButton>
  );
};

Button.defaultProps = {
  $colorScheme: null,
  $noBorder: false,
  bigRounded: false,
  $noOutlineWhenFocus: false,
  leftIcon: null,
  rightIcon: null,
};

export default Button;
